import { useState, useEffect } from 'react';

interface NavbarProps {
  onOpenContact: () => void;
}

export default function Navbar({ onOpenContact }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/697e6f77929f9088e365751998e03758/314605e4b4e6a02bbfa1f915d9b9c8cf.jpeg"
              alt="Soul One Digital"
              className="h-16 w-auto object-contain"
            />
          </div>

          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('hero')}
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Início
            </button>
            <button
              onClick={() => scrollToSection('essence')}
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Nossa Essência
            </button>
            <button
              onClick={() => scrollToSection('solutions')}
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Soluções
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Contato
            </button>
          </div>

          <button
            onClick={onOpenContact}
            className="hidden md:block px-6 py-2.5 bg-purple-600 text-white text-sm font-light tracking-wide rounded-full hover:bg-purple-700 transition-all cursor-pointer whitespace-nowrap"
          >
            Arquitetar meu Projeto
          </button>

          <button className="md:hidden text-white">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
